import {PROPERTY_PUBLIC} from "../property-public.symbol";

/**
 * Marks an entity property as public: its name is appended to the PROPERTY_PUBLIC metadata
 * list of the entity class (read by ChangeTracker and WeeklyWorkingTimeRepository).
 */
export function Public(): PropertyDecorator {

    return function (target: object, propertyKey: string | symbol): void {
        const properties = Reflect.getMetadata(PROPERTY_PUBLIC, target.constructor) || [];
        Reflect.defineMetadata(PROPERTY_PUBLIC, [...properties, propertyKey], target.constructor)
    }

}
